import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router';
import qs from 'query-string';

import TokenStore from 'api/_request/helpers/jwtTokenStore';

import { DispatchType, Redux } from '../../helpers/types/_common';
import { authByAccessToken, googleAuth } from '../../V1/actions/Login/LoginActions';
import SpinnerNew from '../_shared/LoadingSpinnerNew';
import { AuthLocaleParams } from '../../api/Auth/types';
import { deleteFromSessionStorage } from '../../helpers/utils/sessionStorageService';
import { REDIRECT_URL } from '../../helpers/constants/_common/sessionStorageConstants';
import { DEFAULT_PATH, PATH_ADMINISTRATION, PATH_TRACKER, TAB_EMPLOYEES } from '../../helpers/constants/_common/MenuCases';
import { USER_TYPES } from '../../helpers/constants/_common/constants';

interface AppAuthWrapperProps {
  children: React.ReactElement<any, any> | null,
}

const AppAuthWrapper: React.FC<AppAuthWrapperProps> = ({ children }) => {
  const accessToken = TokenStore.getAccessToken();

  const dispatch: DispatchType = useDispatch();
  const history = useHistory();
  const { search, pathname } = useLocation();
  const localeParams: AuthLocaleParams = qs.parse(search);

  const { userDataRequest, userId, isFilledProfile, usertype } = useSelector((state: Redux) => state.login);

  const hasAccessTokenAndLogged = accessToken && userId;
  const hasAccessTokenAndNotLogged = accessToken && !userId;
  const rootDirectory = pathname?.length <= 1;

  useEffect(() => {
    if (history.action !== 'PUSH') {
      deleteFromSessionStorage(REDIRECT_URL);
    }

    if (hasAccessTokenAndNotLogged) {
      dispatch(authByAccessToken());

      return;
    }

    getUserData();
  }, []);

  const getUserData = () => {
    const redirectUri = `${window.location.protocol}//${window.location.host}`;

    if (!localeParams?.code) {
      return;
    }
    const provider = localeParams.provider ? localeParams.provider : "google"

    dispatch(googleAuth({
      code: localeParams.code,
      state: localeParams.state,
      provider: provider,
      redirectUri: provider == "microsoft" ? `${redirectUri}/?provider=${[provider]}` : redirectUri,
    }));
  };

  if (hasAccessTokenAndLogged && rootDirectory && isFilledProfile) {
    if (usertype === USER_TYPES.ADMIN) {
      return <Redirect to={`${PATH_ADMINISTRATION}/${TAB_EMPLOYEES}/${userId}/timesheet`} />;
    } else {
      return <Redirect to={PATH_TRACKER} />;
    }
  }

  if (!accessToken) {
    if (!rootDirectory) {
      return <Redirect to={DEFAULT_PATH} />;
    }
  }

  if (hasAccessTokenAndNotLogged || localeParams?.code || userDataRequest.isLoading) {
    return <SpinnerNew />;
  }

  return children;
};

export default AppAuthWrapper;
